import { format } from 'date-fns';
import { useScopedI18n } from '@locales/client';

import { HintContainer, Hint, HintBold } from './styles';
import { useFormatAmount } from '@/shared/hooks/useFormatAmount';

type RenderHintT = {
  needBets: number;
  needBetsTS: number;
};

export const RenderHint = ({ needBets, needBetsTS }: RenderHintT) => {
  const s = useScopedI18n('status');
  const formatAmount = useFormatAmount({ mode: 'plain' });

  return (
    <HintContainer>
      <Hint>
        {s('hint', {
          value: (
            <HintBold>
              {formatAmount(needBets)}
            </HintBold>
          ),
          date: (
            <HintBold>{format(needBetsTS * 1000, 'dd.MM.yyyy HH:mm')}</HintBold>
          ),
        })}
      </Hint>
    </HintContainer>
  );
};
